import { toast } from "react-toastify";
import SearchTable from "../../components/SearchTable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableColumn, SortParams } from "../../components/Table";
import { TFunction } from "i18next";
import { getAxiosInstance } from "../../utils/axiosInstance";
import ModalProductProvider from "./ModalProductProvider";
import PageHead from "../../components/PageHead";
import ModalAddProductProvider from "./ModalAddProductProvider";
import { Center, Flex, Icon, Text, Tooltip } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";


const getColumns = (t: TFunction<any>) => [
    {
        Header: t("CRT_NO"),
        accessor: 'no'
    },
    {
        Header: t("Name"),
        accessor: 'name'
    },
    {
        Header: t("C.U.I"),
        accessor: 'cui'
    },
    {
        Header: t("Address"),
        accessor: 'address'
    },
    {
        Header: t("Phone Number"),
        accessor: 'phoneNumber'
    },
    {
        Header: t("Email"),
        accessor: 'email'
    },
    {
        Header: t("Country"),
        accessor: 'country'
    },
]

type ProductProvider = {
    id: string,
    productId: string,
    providerId: string,
    provider: {
        id: string,
        name: string,
        cui: string,
        address: string,
        phoneNumber: string,
        email: string,
        country: string,
        isDeleted: boolean
    }
}[]

type ProductProviderRendered = {
    id: string,
    name: string,
    cui: string,
    address: string,
    phoneNumber: string,
    email: string,
    country: string,
    isDeleted: boolean
}



const ProductProvider = (props: { productId: string }) => {
    const [fData, setFData] = useState<any[]>([]);
    const [length, setLength] = useState<number>(0);
    const [deleteProviderId, setDeleteProviderId] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);
    const [search, setSearch] = useState<string>("");
    const [sortParmas, setSortParams] = useState<SortParams | null>(null);

    const [openProviderModal, setOpenProviderModal] = useState<boolean>(false);
    const [addProductProviders, setAddProductProviders] = useState<boolean>(false);

    const { t } = useTranslation("translations");

    const fetchData = async (
        currentPage: number = 1,
        perPage: number = 10,
        search: string | undefined,
        sortParams: SortParams | null
    ) => {
        try {
            const res = await getAxiosInstance().get('/productProviders', {
                params: {
                    ProductId: props.productId,
                    PageNumber: currentPage,
                    PageSize: perPage,
                    SearchString: search,
                    SearchField: search ? "Name" : undefined,
                    SortBy: sortParams ? sortParams.sortBy : undefined,
                    SortDesc: sortParams ? sortParams.isSortedDesc : undefined
                }
            });

            const paginationData = JSON.parse(res.headers.pagination);
            setLength(paginationData.totalItems);
            setFData(formData(res.data, (paginationData.currentPage - 1) * paginationData.itemsPerPage));
        } catch (e) {
            console.log(e);
            toast.error(
                t("SOMETHING_WENT_WRONG"),
                { position: toast.POSITION.BOTTOM_RIGHT }
            );
        }
    };

    const formData = (data: ProductProvider, length: number): ProductProviderRendered[] => {
        const lProductProvider: ProductProviderRendered[] = [];
        let i = 0;
        for (const a of data) {
            i++;
            let x = {
                id: a.provider.id,
                no: i,
                name: a.provider.name,
                cui: a.provider.cui,
                address: a.provider.address,
                phoneNumber: a.provider.phoneNumber,
                email: a.provider.email,
                country: a.provider.country,
                isDeleted: a.provider.isDeleted

            }
            lProductProvider.push(x);
        }
        return lProductProvider;
    }

    useEffect(() => {
        fetchData(1, 10, undefined, null);
    }, [length])

    return (
        <>
            <PageHead
                name={t("Product Providers")}
                addTooltip={t("Add Providers for Product")}
                onAddModal={() => { setAddProductProviders(true) }}
            />
            {
                length !== 0 ?
                    <>
                        <SearchTable
                            columns={getColumns(t)}
                            data={fData}
                            dataLength={length}
                            onRowClick={(data) => { setOpenProviderModal(true); setDeleteProviderId(data.id) }}
                            fetchData={(data) => fetchData(data.page, data.perPage, data.searchTerm, data.sortParams)}
                            page={page}
                            perPage={perPage}
                            setPage={setPage}
                            setPerPage={setPerPage}
                            search={search}
                            setSearch={setSearch}
                            sortParams={sortParmas}
                            setSortParams={setSortParams}
                        />
                    </> :
                    <>
                        <Center>
                            
                            <Text fontSize={"3xl"}> {t("Zero Providers!")} </Text>
                            
                        </Center> </>
            }


            <ModalProductProvider
                onClose={() => { setOpenProviderModal(false); fetchData(1, 10, undefined, null); }}
                isOpen={openProviderModal}
                providerId={deleteProviderId}
                productId={props.productId}

            />

            <ModalAddProductProvider
                onClose={() => { setAddProductProviders(false); fetchData(1, 10, undefined, null); }}
                isOpen={addProductProviders}
                productId={props.productId}
            />
        </>
    )
}

export default ProductProvider;